export default __webpack_public_path__ + "static/5-50e4b5b186c376d6e51927db637b9e1a.jpg";